import { Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSButton from "../../../Components/Button/WSButton";
// import BannerImage from '../../../FrontEnd/Images/Banner/1.jpg'

import {
  callAPI,
  clearRequest,
  EPhone,
  formatPhoneNumber,
  Method
} from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import { Header } from "../../../Components/Header/Header";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSDateField from "../../../Components/DateField/WSDateField";
import dayjs from "dayjs";
import WSSelectField from "../../../Components/Select/WSSelect";
import clientConfig from "../../../Config/clientConfig.json";
import WSRadioField from "../../../Components/Radio/WSRadio";
import WSPhone from "../../../Components/Phone/WSPhone";
import axios from "axios";
import config from "../../../Config/config.json";
import httpDash from "../../../commonFunctions/htttpClientNew";
export const Supplier: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const id = params?.id;
  const [defaultImg, setDefaultImg] = useState<any | null>(null);
  const [startDate, setStartDate] = useState<string>();

  useEffect(
    () => () => {
      reset();
    },
    []
  );
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getPromotionById(id: any) {
      try {
        const response: any = await httpDash.get(`Supplier/${id}`);
        console.log("response", response);

        if (response && response?.data) {
          setValue("name", response.data.name);
          setValue("category", response.data.category);
          // setValue("contact",formatPhoneNumber(response.data.contact, EPhone.AddHyphen), response.data.contact);
          setValue("id", response.data.id);
        }
      } catch (error) {
        console.log("failed to retrieve data", error);
      }
    }
    if (id) {
      getPromotionById(id);
    }
  }, [id, setValue]);

  /**
   * Method for Add/Update the data
   * @param data
   */
  const handleData = async (data: any) => {
    try {
      let request = {
        name: data.name,
        category: data.category?.toString(),
        address: ".",
        contact: formatPhoneNumber(data.contact, EPhone.RemoveHyphen)
        // contact: formatPhoneNumber('0', EPhone.RemoveHyphen)
      };

      // const newRequest = clearRequest(request)
      if (id) {
        const response: any = await httpDash.put(`Supplier/${id}`, request);
        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          if (response?.success === true) {
            navigate("/supplier/list");
          }
        }
      } else {
        const response: any = await httpDash.post(`Supplier`, request);
        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          if (response?.success === true) {
            navigate("/supplier/list");
          }
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    }
  };

  const handleCancelClick = () => {
    navigate("/supplier/list");
  };

  return (
    <>
      <Header
        type="simple"
        isDivider={true}
        title={`${id ? "Edit" : "Add"} Supplier`}
        url="/supplier/list"
        id={"promotionImg"}
        isBackButton={true}
        headerSx={{ marginTop: 0 }}
      />
      <form onSubmit={handleSubmit(handleData)}>
        <Grid
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 2,
            border: "1px solid lightgrey",
            marginTop: 3
          }}
        >
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Name"}
                {...register("name")}
                id="name"
                name="name"
                control={control}
                rules={{ required: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSPhone
                label={"Contact"}
                id={"contact"}
                name={"contact"}
                control={control}
                rules={{ required: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSSelectField
                label={"Category"}
                {...register("category")}
                id="category"
                name="category"
                control={control}
                options={clientConfig.supplierCreditTermConfig.staticOptionData}
                rules={{ required: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6} style={{ display: "none" }}>
              <WSHiddenField name="id" control={control} />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "3rem",
                display: "flex",
                justifyContent: "flex-end",
                gap: 2
              }}
            >
              <WSButton
                id="submit"
                label={"Save"}
                type="submit"
                size="medium"
              />
              <WSButton
                id="cancel"
                label={"Cancel"}
                type="button"
                onClick={handleCancelClick}
                size="medium"
                className="ws-cancel"
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
});
